// 计算文件的大小
export function renderSize(filesize){
    if(null==filesize||filesize==''){
        return "0 Bytes";
    }
    var unitArr = new Array("Bytes","KB","MB","GB","TB","PB","EB","ZB","YB");
    var index=0;
    var srcsize = parseFloat(filesize);
    index=Math.floor(Math.log(srcsize)/Math.log(1024));
    var size =srcsize/Math.pow(1024,index);
    size=size.toFixed(2);//保留的小数位数
    return size+unitArr[index];
}
//获取下载原始数据的命令行
export function  getCommand(name,link,){
    return `(curl -C - -f -o ${name} -H 'Command-Download:1' ${link} || curl -C - -H 'Command-Download:1' ${link})`
}
